class invalidInputFocus {
    constructor() {
        this.formElements = document.querySelectorAll('input, textarea, select');

        if (!this.formElements.length) {
            return
        }
        this.removeValidationError(this.formElements);
    }

    removeValidationError(formElements) {
        [].forEach.call(formElements, (formElement) => {
            formElement.addEventListener('click', () => {
                if (formElement.classList.contains('input-validation-error')) {
                    formElement.classList.remove('input-validation-error');
                    formElement.parentElement.querySelector('.field-validation-error').style.display = 'none';
                }
            });
        });
    }
}

export {invalidInputFocus};